import danceSvg from '@gymondo/frontend-core/svg/body-dance.svg'
import heartCardio from '@gymondo/frontend-core/svg/heart-cardio.svg'
import food from '@gymondo/frontend-core/svg/food-type-10.svg'
import checkList from '@gymondo/frontend-core/svg/checklist.svg'

export const TRANSLATION_KEY_PREFIX = 'how-it-works'
const ICON_COMPONENT_KEY = 'icon'
const SECTION_COMPONENT_KEY = 'card'

export const hero = {
    title: [
        `${TRANSLATION_KEY_PREFIX}.hero.line1`,
        `${TRANSLATION_KEY_PREFIX}.hero.line2`,
    ],
    subtitle: `${TRANSLATION_KEY_PREFIX}.subhero`,
}

const _getTextConfig = (num, component) => ({
    title: `${TRANSLATION_KEY_PREFIX}.${component}.${num}.title`,
    subtitle: `${TRANSLATION_KEY_PREFIX}.${component}.${num}.subtitle`,
})

export const iconsConfig = [
    {
        ..._getTextConfig(1, ICON_COMPONENT_KEY),
        svg: danceSvg,
    },
    {
        ..._getTextConfig(2, ICON_COMPONENT_KEY),
        svg: heartCardio,
    },
    {
        ..._getTextConfig(3, ICON_COMPONENT_KEY),
        svg: food,
    },
    {
        ..._getTextConfig(4, ICON_COMPONENT_KEY),
        svg: checkList,
    },
]

export const sectionsConfig = [
    {
        ..._getTextConfig(1, SECTION_COMPONENT_KEY),
        hasContent: true,
    },
    {
        ..._getTextConfig(2, SECTION_COMPONENT_KEY),
        hasDownloadGroup: true,
        hasCta: true,
    },
    {
        ..._getTextConfig(3, SECTION_COMPONENT_KEY),
        reversed: true,
    },
    {
        ..._getTextConfig(4, SECTION_COMPONENT_KEY),
        zoomImageOnMobile: false,
        hasCta: true,
    },
    {
        ..._getTextConfig(5, SECTION_COMPONENT_KEY),
        zoomImageOnMobile: false,
        reversedMobile: true,
        hasCta: true,
    },
    {
        ..._getTextConfig(6, SECTION_COMPONENT_KEY),
        reversed: true,
        reversedMobile: true,
        zoomImageOnMobile: false,
        className: 'leftAligned',
    },
]
